import React from 'react';
import DocumentReader from './DocumentReader';
import { documentTitle, documentSlug, parts } from './content/grammarReference';

export default function GrammarReference() {
  return (
    <DocumentReader
      documentId={documentSlug}
      title={documentTitle}
      intro="Core Standard English Conventions rules tested on the Reading and Writing section, reproduced in full and highlightable."
      parts={parts}
    />
  );
}
